const ScrollBodySection = () => (
    <div id="ScrollBodySection">
        <div id="ScrollBodyCenter"></div>
    </div>
);

export default ScrollBodySection;
